import React from 'react';
import { Background, ContentCtn, SlaGraphCtn, JobCount } from './index.style';

interface SlaProps {
  maxCount: number;
  count: number;
  children?: React.ReactChild;
  title: string;
  primaryColor: string;
  secondaryColor: string;
}

const SlaGraph: React.FC<SlaProps> = ({
  count,
  children,
  maxCount,
  primaryColor,
  secondaryColor,
  title,
  onClick,
}): React.ReactElement => {
  return (
    <SlaGraphCtn onClick={onClick}>
      <Background secondaryColor={secondaryColor} width={(count / maxCount) * 85} />
      <ContentCtn primaryColor={primaryColor}>
        {children}
        <span>{title}</span>
      </ContentCtn>
      <JobCount>{count}</JobCount>
    </SlaGraphCtn>
  );
};

export default SlaGraph;
